import { useEffect, useState, useContext } from "react";
import { getAllInventory } from "../../Utils/localStore";
import TablePlaceholder from "../../Utils/TablePlaceholder";
import ToastContext from "../../context/toasterContex";
import ContextApi from "../../context/ContextApi";

export default function ProductShelf(props) {
    const { product, setProducts } = useContext(ContextApi)
    const { toast } = useContext(ToastContext)
    const [drugs, setDrugs] = useState(null)
    const [selectedDrugs, setSelectedDrugs] = useState([])

    const getLocalData = async () => {
        let response
        try {
            await getAllInventory().then(resp => response = resp)
            return setDrugs(response)
        } catch (error) {
            toast.error(error, { position: toast.POSITION.TOP_CENTER })
            throw new Error(error)
        }
    }

    const handleSelectedDrug = (e, drug) => {
        e.preventDefault()
        const newDrugs = [...drugs]
        newDrugs.map(t => {
            if (+t.localID === +drug.localID) {
                if (drug.selected) {
                    t.selected = !t.selected
                    let newlp = [...selectedDrugs]
                    const findByID = newlp.findIndex(item => item.localID == drug.localID)
                    newlp.splice(findByID, 1)
                    setSelectedDrugs(newlp)
                } else {
                    t.selected = true
                    setDrugs(() => [
                        ...newDrugs
                    ])
                    let newlp = [...selectedDrugs]
                    newlp = [...newlp, drug]
                    setSelectedDrugs(newlp)
                }
            } else {
                return t;
            }
        })
    }
    const handleNext = () => {
        setProducts(selectedDrugs)
        props.onContinue()
    }

    useEffect(() => {
        getLocalData()
    }, []);
    return (
        <section className=" w-full px-12">
            <h1 className="text-[20px] mt-6 font-black">Product Shelf</h1>
            <input type="text" className="border-grey-100 border rounded-[20px] p-2" placeholder="Search Items" />
            <div className="tags mt-[30px]">
                <div className="md:flex justify-start">
                    <div className="flex justify-between gap-4 w-full">
                        <div className="flex justify-start gap-3">
                            <div className="tab rounded w-[32px] shadow-md grid place-items-center  bg-primary h-[40px] text-[white]">All</div>

                            <div className="inline-flex justify-center text-sky-600 shadow-md border border-grey-100 h-[40px] place-items-center bg-white rounded-[10px] px-3">Pharmaceuticals</div>

                            <div className="inline-flex justify-center align-middle text-sky-600 shadow-md border border-grey-100 h-[40px] bg-white place-items-center rounded-[10px] px-2">Surgical and clinical items</div>
                        </div>
                        {
                            selectedDrugs.length ?
                                (
                                    <button
                                        className="bg-primary text-white p-2 w-38 justify-self-end rounded"
                                        onClick={handleNext}
                                    >
                                        Goto Checkout ({selectedDrugs.length ?? selectedDrugs.length})
                                    </button>
                                )
                                :
                                ''
                        }
                    </div>

                </div>
                <div className="md:flex justify-start mt-4 flex-wrap gap-3">
                    {
                        drugs && drugs.length
                            ?
                            drugs?.map((data, id) => {
                                return (<div className="border border-grey-100 w-full md:w-[220px] mb-3 rounded-[5px] p-2 capitalize relative cursor-pointer" key={id} onClick={(e) => handleSelectedDrug(e, data)}>
                                    {
                                        data?.selected &&
                                        <div className="rounded-full w-4 h-4 bg-primary text-white absolute right-2">
                                            <div className="flex justify-center align-middle text-[11px]">
                                                {'✓'}
                                            </div>
                                        </div>
                                    }
                                    <div className="font-bold">
                                        <div className="flex justify-between gap-2">
                                            <p className="line-clamp-1 w-90" name={data.name} title={data.name}>
                                                {data.name}
                                            </p>
                                            <p>{' '}</p>
                                        </div>
                                        <p className="opacity-70 text-sm w-10 w-full" >
                                            {data.brand}
                                        </p>
                                    </div>
                                    <div className="flex justify-between">
                                        <div className="inline-flex">
                                            {data.unit_quantity}
                                            <p>
                                                {data.measurement}
                                            </p>
                                        </div>
                                        <div>
                                            <span className="ml-3">
                                                ₦
                                            </span>
                                            {' ' + data.price}
                                        </div>

                                    </div>
                                </div>)
                            })
                            :
                            <TablePlaceholder />
                    }

                </div>
            </div>
        </section>
    );
}